import script from "./WorksonaContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorksonaContainer.vue?vue&type=script&setup=true&lang=ts"

import "./WorksonaContainer.vue?vue&type=style&index=0&id=c502a0a2&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src057020910/src/SAAS-mobile-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c502a0a2"]])

export default __exports__